/**
 * Super class of all symbols
 */
define("tmds/symbols/Symbol", [

], function() {
	"use strict";
	
	var Symbol = function() {};
	
	/**
	 * convert Symbol object to JSON representation
	 */
	function toJson() {
		return {
			type: this.type
		};
	}
	
	Symbol.prototype = {
		declaredClass: "tmds.symbols.Symbol",
		type: "Symbol",
		'toJson' : toJson
	};
	
	return Symbol;
});